import React from "react"
import { MainCP } from "../../Components/conocimiento/MainCP"

const ViewConocimiento: React.FC = () => <MainCP/>

export default ViewConocimiento